export default {
  name: "crm",
  component: () =>
    import(
      /* webpackChunkName: "crm-layout" */ "@/modules/crm/layouts/CrmLayout.vue"
    ),
  redirect: "/crm/opcionesInteracciones/interacciones",
  children: [
    {
      path: "opcionesInteracciones",
      name: "crm-opcionesInteracciones",
      redirect: "/crm/opcionesInteracciones/interacciones",
      component: () =>
        import(
          /* webpackChunkName: "crm-opcionesInteracciones" */ "@/modules/crm/pages/interacciones/OpcionesInteracciones.vue"
        ),
      children: [
        {
          path: "interacciones",
          name: "crm-interacciones",
          component: () =>
            import(
              /* webpackChunkName: "crm-interacciones" */ "@/modules/crm/pages/interacciones/Interacciones.vue"
            ),
        },
        {
          path: "interaccionesWpp",
          name: "crm-interaccionesWpp",
          component: () =>
            import(
              /* webpackChunkName: "crm-interaccionesWpp" */ "@/modules/crm/pages/interacciones/InteraccionesWpp.vue"
            ),
        },
        {
          path: "interaccionesFacebook",
          name: "crm-interaccionesFace",
          component: () =>
            import(
              /* webpackChunkName: "crm-interaccionesFace" */ "@/modules/crm/pages/interacciones/Facebook.vue"
            ),
        },
        {
          path: "interaccionesFormulario",
          name: "crm-interaccionesForm",
          component: () =>
            import(
              /* webpackChunkName: "crm-interaccionesForm" */ "@/modules/crm/pages/interacciones/Formulario.vue"
            ),
        },
        {
          path: "interaccionesJoin",
          name: "crm-interaccionesJoin",
          component: () =>
            import(
              /* webpackChunkName: "crm-interaccionesJoin" */ "@/modules/crm/pages/interacciones/Join.vue"
            ),
        },
        {
          path: "interaccionesCrm",
          name: "crm-interaccionesCrm",
          component: () =>
            import(
              /* webpackChunkName: "crm-interaccionesCrm" */ "@/modules/crm/pages/interacciones/Crm.vue"
            ),
        },
        {
          path: "recompraCrm",
          name: "crm-recompra",
          component: () =>
            import(
              /* webpackChunkName: "crm-recompra" */ "@/modules/crm/pages/interacciones/Recompra.vue"
            ),
        },
        {
          path: "clientesAntiguosCrm",
          name: "crm-clientesAntiguos",
          component: () =>
            import(
              /* webpackChunkName: "crm-clientesAntiguos" */ "@/modules/crm/pages/interacciones/ClientesAntiguos.vue"
            ),
        },
      ],
    },
    {
      path: "opcionesPersona",
      name: "crm-opcionesPersona",
      component: () =>
        import(
          /* webpackChunkName: "crm-opcionesPersona" */ "@/modules/crm/pages/personas/OpcionesPersonas.vue"
        ),
      children: [
        {
          path: "personas",
          name: "crm-personas",
          component: () =>
            import(
              /* webpackChunkName: "crm-personas" */ "@/modules/crm/pages/personas/Personas.vue"
            ),
        },
      ],
    },
    {
      path: "empresas",
      name: "crm-empresas",
      component: () =>
        import(
          /* webpackChunkName: "crm-empresas" */ "@/modules/crm/pages/Empresas.vue"
        ),
    },
    {
      path: "opcionesLeads",
      name: "crm-opcionesLeads",
      component: () =>
        import(
          /* webpackChunkName: "crm-opcionesLeads" */ "@/modules/crm/pages/leads/OpcionesLeads.vue"
        ),
      children: [
        {
          path: "leads",
          name: "crm-leads",
          component: () =>
            import(
              /* webpackChunkName: "crm-leads" */ "@/modules/crm/pages/leads/Leads.vue"
            ),
        },
      ],
    },
    {
      path: "opcionesVentas",
      name: "crm-opcionesVentas",
      component: () =>
        import(
          /* webpackChunkName: "crm-opcionesVentas" */ "@/modules/crm/pages/ventas/OpcionesVentas.vue"
        ),
      redirect: "/crm/opcionesVentas/ventas",
      children: [
        {
          path: "ventas",
          name: "crm-ventas",
          component: () =>
            import(
              /* webpackChunkName: "crm-ventas" */ "@/modules/crm/pages/ventas/Ventas.vue"
            ),
        },
      ],
    },
    {
      path: "agenda",
      name: "crm-agenda",
      component: () =>
        import(
          /* webpackChunkName: "crm-agenda" */ "@/modules/crm/pages/Agenda/Agenda.vue"
        ),
    },
    {
      path: "opcionesNegocio",
      name: "crm-opcionesNegocio",
      component: () =>
        import(
          /* webpackChunkName: "crm-opcionesNegocio" */ "@/modules/crm/pages/negocios/OpcionesNegocio.vue"
        ),
      redirect: "/crm/opcionesNegocio/negociosLista",
      children: [
        {
          path: "negociosPorFase",
          name: "crm-negociosPorFase",
          component: () =>
            import(
              /* webpackChunkName: "crm-negociosPorFase" */ "@/modules/crm/pages/negocios/NegociosFace.vue"
            ),
        },
        {
          path: "negociosLista",
          name: "crm-negocios",
          component: () =>
            import(
              /* webpackChunkName: "crm-negocios" */ "@/modules/crm/pages/negocios/Negocios.vue"
            ),
        },
      ],
    },
    {
      path: "detalle/:id/:idInteraccion?",
      name: "crm-detail",
      component: () =>
        import(
          /* webpackChunkName: "crm-detail" */ "@/modules/crm/components/shared/Detail.vue"
        ),
      props: (route) => {
        return {
          id: route.params.id,
          idInteraccion: route.params.idInteraccion,
        };
      },
    },
    {
      path: "configuraciones",
      name: "crm-configuraciones",
      component: () =>
        import(
          /* webpackChunkName: "crm-configuraciones" */ "@/modules/crm/pages/configuraciones/Configuraciones.vue"
        ),
      redirect: "/crm/configuraciones/fases",
      children: [
        {
          path: "fases",
          name: "crm-fases",
          component: () =>
            import(
              /* webpackChunkName: "crm-fases" */ "@/modules/crm/pages/configuraciones/Fases.vue"
            ),
        },
        {
          path: "necesidades",
          name: "crm-necesidades",
          component: () =>
            import(
              /* webpackChunkName: "crm-necesidades" */ "@/modules/crm/pages/configuraciones/Necesidades.vue"
            ),
        },
        {
          path: "variables",
          name: "crm-variables",
          component: () =>
            import(
              /* webpackChunkName: "crm-variables" */ "@/modules/crm/pages/configuraciones/Variables.vue"
            ),
        },
        {
          path: "configuracionVariables",
          name: "crm-configuracionVariables",
          component: () =>
            import(
              /* webpackChunkName: "crm-configuracionVariables" */ "@/modules/crm/pages/configuraciones/ConfiguracionVariables.vue"
            ),
        },
        {
          path: "configuracionesTipoVariables",
          name: "crm-configuracionesTipoVariables",
          component: () =>
            import(
              /* webpackChunkName: "crm-configuracionesTipoVariables" */ "@/modules/crm/pages/configuraciones/TipoVariables.vue"
            ),
        },
        {
          path: "configuracionEstadoLead",
          name: "crm-status-lead",
          component: () =>
            import(
              /* webpackChunkName: "crm-status-lead" */ "@/modules/crm/pages/configuraciones/EstadoLead.vue"
            ),
        },
        {
          path: "configuracionFormularios",
          name: "crm-forms",
          component: () =>
            import(
              /* webpackChunkName: "crm-forms" */ "@/modules/crm/pages/configuraciones/Forms.vue"
            ),
        },
        {
          path: "origenes",
          name: "crm-origin",
          component: () =>
            import(
              /* webpackChunkName: "crm-origin" */ "@/modules/crm/pages/configuraciones/Origenes.vue"
            ),
        },
        {
          path: "testForm",
          name: "crm-testForm",
          component: () =>
            import(
              /* webpackChunkName: "crm-testForm" */ "@/modules/crm/pages/configuraciones/TestForm.vue"
            ),
        },
        {
          path: "lineasNegocio",
          name: "crm-lineasNegocio",
          component: () =>
            import(
              /* webpackChunkName: "crm-lineasNegocio" */ "@/modules/crm/pages/configuraciones/LineasNegocio.vue"
            ),
        },
        {
          path: "campaigns",
          name: "crm-campaigns",
          component: () =>
            import(
              /* webpackChunkName: "crm-campaigns" */ "@/modules/crm/pages/configuraciones/Campaigns.vue"
            ),
        },
        {
          path: "grupos",
          name: "crm-agenda-grupos",
          component: () =>
            import(
              /* webpackChunkName: "crm-agenda-grupos" */ "@/modules/crm/pages/configuraciones/GruposEventos.vue"
            ),
        },
      ],
    },
  ],
};
